import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import useSeo from '../hooks/useSeo.ts'

const NotFound: React.FC = () => {
	const { pathname } = useLocation()
	useSeo({ title: 'Stranica nije pronađena | Wedding Camera', description: 'Tražena stranica nije pronađena.', path: pathname, lang: 'hr', noindex: true })
	return <main style={{ padding: '60px 24px', textAlign: 'center' }}>
		<h1>Stranica nije pronađena</h1>
		<p>Page not found.</p>
		<Link to='/'>Wedding Camera</Link>
	</main>
}

export default NotFound
